import MUIButton from '@mui/material/Button';

export const Button = (props?: any): JSX.Element => (
  <MUIButton variant="contained" color="primary" {...props} />
);
